/**
 * Phone normalisation helpers, mirroring `WebOnboardingPhoneVerificationScreen` (PF-6119). Duplicated
 * locally rather than imported: that screen's helpers are module-private, and lifting them into a
 * shared util lives in `src/features/webAppOnboarding/`, outside this page's scope.
 */

/** Digits-only, `+`-prefixed E.164, same normalisation `webAppOnboardingAuthentication` uses. */
export function normalizePhoneForAuth(raw: string): string {
  const trimmed = raw.trim();
  if (!trimmed) {
    return '';
  }

  if (trimmed.startsWith('+')) {
    return `+${trimmed.slice(1).replace(/\D/g, '')}`;
  }

  const digits = trimmed.replace(/\D/g, '');
  if (!digits) {
    return '';
  }

  if (digits.startsWith('00')) {
    return `+${digits.slice(2)}`;
  }
  if (digits.startsWith('0')) {
    return `+49${digits.slice(1)}`;
  }
  if (digits.startsWith('49')) {
    return `+${digits}`;
  }
  return `+${digits}`;
}

export function buildE164FromParts(countryCode: string, nationalNumber: string): string {
  const ccDigits = countryCode.replace(/\D/g, '');
  const nationalDigits = nationalNumber.replace(/\D/g, '');
  if (!ccDigits || !nationalDigits) {
    return '';
  }
  return `+${ccDigits}${nationalDigits}`;
}

export function toCallablePhone(countryCode: string, nationalNumber: string): string {
  return normalizePhoneForAuth(buildE164FromParts(countryCode, nationalNumber));
}
